import { useTranslation } from "react-i18next";
import { EmptyState } from "../../components/ui/EmptyState/EmptyState";

/**
 * Generic error surface. Rendered by Sentry's `ErrorBoundary` as the
 * fallback when an uncaught exception crashes the route tree.
 *
 * Composes the shared `EmptyState` primitive so this, the forbidden,
 * and the not-found pages stay in visual sync. No action button on
 * purpose: when this surface renders, the app shell may not be
 * reliable enough to navigate from.
 */
export default function ErrorPage() {
  const { t } = useTranslation("common");
  return (
    <EmptyState
      variant="page"
      title={t("errorPages.errorTitle")}
      description={t("errorPages.errorDesc")}
    />
  );
}
